var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "svg",
    {
      style: { marginTop: _vm.marginTop },
      attrs: {
        width: _vm.width,
        height: _vm.height,
        viewBox: "0 0 16 23",
        fill: _vm.fill,
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M7.88086 0C3.52387 0 0 3.52387 0 7.88086C0 13.7915 7.88086 22.5167 7.88086 22.5167C7.88086 22.5167 15.7617 13.7915 15.7617 7.88086C15.7617 3.52387 12.2378 0 7.88086 0ZM2.25167 7.88086C2.25167 4.77355 4.77355 2.25167 7.88086 2.25167C10.9882 2.25167 13.51 4.77355 13.51 7.88086C13.51 11.1233 10.2676 15.9756 7.88086 19.0041C5.53912 15.9981 2.25167 11.0895 2.25167 7.88086Z",
        },
      }),
      _c("path", {
        attrs: {
          d: "M7.881 10.6956C9.43546 10.6956 10.6956 9.43546 10.6956 7.881C10.6956 6.32654 9.43546 5.06641 7.881 5.06641C6.32654 5.06641 5.06641 6.32654 5.06641 7.881C5.06641 9.43546 6.32654 10.6956 7.881 10.6956Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }